var map = {
	"./Error": [
		2986,
		986
	],
	"./Error.vue": [
		2986,
		986
	],
	"./frontend/AboutUs": [
		5899,
		899
	],
	"./frontend/AboutUs.vue": [
		5899,
		899
	],
	"./frontend/Bemer": [
		7772,
		772
	],
	"./frontend/Bemer.vue": [
		7772,
		772
	],
	"./frontend/Coffeetalk": [
		8850,
		850
	],
	"./frontend/Coffeetalk.vue": [
		8850,
		850
	],
	"./frontend/Contact": [
		1838,
		838
	],
	"./frontend/Contact.vue": [
		1838,
		838
	],
	"./frontend/Hiking": [
		3414,
		414
	],
	"./frontend/Hiking.vue": [
		3414,
		414
	],
	"./frontend/Imprint": [
		7429,
		429
	],
	"./frontend/Imprint.vue": [
		7429,
		429
	],
	"./frontend/Index": [
		3848,
		848
	],
	"./frontend/Index.vue": [
		3848,
		848
	],
	"./frontend/Interestingfacts": [
		7755,
		755
	],
	"./frontend/Interestingfacts.vue": [
		7755,
		755
	],
	"./frontend/PrivacyPolicy": [
		8176,
		795
	],
	"./frontend/PrivacyPolicy.vue": [
		8176,
		795
	],
	"./frontend/Shop": [
		5492,
		492
	],
	"./frontend/Shop.vue": [
		5492,
		492
	],
	"./frontend/Terms": [
		6434,
		434
	],
	"./frontend/Terms.vue": [
		6434,
		434
	],
	"./frontend/Visit": [
		2751,
		751
	],
	"./frontend/Visit.vue": [
		2751,
		751
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1128;
module.exports = webpackAsyncContext;